import React from 'react';
import { Icon } from './Icon.js';
export const IconHouse3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M10.0591 1.36312C9.4333 0.886569 8.56694 0.887445 7.94127 1.36281L2.69155 5.3526C2.2559 5.68346 2 6.19867 2 6.746V14.25C2 15.7692 3.23079 17 4.75 17H7.25V13.5C7.25 12.534 8.034 11.75 9 11.75C9.966 11.75 10.75 12.534 10.75 13.5V17H13.25C14.7692 17 16 15.7692 16 14.25V6.746C16 6.20008 15.7448 5.68398 15.3088 5.35287L10.0591 1.36312Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconHouse3Fill18.js.map